import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Role } from '@core/models';

@Component({
    selector: 'app-role-chip',
    templateUrl: './role-chip.component.html',
    styleUrls: ['./role-chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoleChipComponent implements OnInit {
  static readonly componentName = 'RoleChipComponent';
  
  @Output() removeRole = new EventEmitter<Role>();
  @Input() inputRole: Role;
  @Input() isRemovingRole: boolean;
  @Input() removeLabel: string;

  constructor() {}

  ngOnInit(): void {}

  onRemoveRole(e: MouseEvent) {
    e.stopPropagation();
    this.removeRole.emit(this.inputRole);
  }
}
